import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import { translate } from './scripts/utils';

sync(store, router);
Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
Vue.prototype.$t = k => translate(k);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
